import { render, staticRenderFns } from "./docSendView.vue?vue&type=template&id=2087f0a6&scoped=true"
import script from "./docSendView.vue?vue&type=script&lang=js"
export * from "./docSendView.vue?vue&type=script&lang=js"
import style0 from "./docSendView.vue?vue&type=style&index=0&id=2087f0a6&prod&lang=less&scoped=true"
import style1 from "./docSendView.vue?vue&type=style&index=1&id=2087f0a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2087f0a6",
  null
  
)

export default component.exports